module.exports = new __parcel__URL__("code-page.tpl.25f770f0.svg").toString();